export default {
  state: {
    orders: [],
    tmpOrders: [],
    orderNumber: "",
    startPrint: false,
    warehouse_id: "",
    tax_discount: {
      discount_percent: 0,
      tax: 0,
      tax_price: 0,
      discount: 0,
    },
    total: 0,
    subtotal: 0,
    purchasetotal: 0,
    keyword: "",
    salePriceModalId: "",
    holdOrders: [],
    refund_paid: {
      refund: "",
      paid: "",
    },
    customers:{
      name:"",
      phone:"",
      address:""
    },
    showSalePriceModal: true,
    shop_info: {},
    isReceipt: false,
    curretnCategoryId: "",
  },
  getters: {
    getStartPrint(state) {
      return state.startPrint;
    },
    // search
    getKeyword(state) {
      return state.keyword;
    },
    getShopInfo(state) {
      return state.shop_info;
    },
    getIsReceipt(state) {
      return state.isReceipt;
    },
    getProducts(state) {
      return state.tmpOrders;
    },
    getCurrentCategoryId(state) {
      return state.curretnCategoryId;
    },
    getCustomers(state){
      return state.customers;
    }
  },
  mutations: {
    SET_PAID_REFUND: (state, payload) => (state.paid_refund = payload),
    SET_START_PRINT: (state, payload) => (state.startPrint = payload),
    SET_ORDER_NUMBER: (state, payload) => (state.orderNumber = payload),
    SET_CUSTOMER: (state, payload) => {
      state.customers.name = payload.name;
      state.customers.phone = payload.phone;
      state.customers.address = payload.address;
    },
    ADD_TMP_ORDER: (state, payload) => (state.tmpOrders = payload),
    ADD_ORDER: (state, payload) => {
      state.orders.unshift(payload);
      console.log(payload);
      let currentProduct = state.tmpOrders.find(
        (product) => product.id == payload.id
      );
      currentProduct.count += 1;
    },
    // ADD_ORDER: (state, payload) => console.log("order", payload),
    SET_ORDER: (state, payload) => {
      state.orders = payload;
      console.log(payload);
    },
    INC_ORDER: (state, payloadId) => {
      let order = state.orders.find((order) => order.id == payloadId);
      let currentProduct = state.tmpOrders.find(
        (product) => product.id == payloadId
      );
      currentProduct.count += 1;
      order.qty += 1;
      order.purchase_total = order.purchase_price * order.qty;
      order.total = order.price * order.qty;
    },
    DEC_ORDER: (state, payloadId) => {
      let order = state.orders.find((order) => order.id == payloadId);
      let tempOrder = state.tmpOrders.find((order) => order.id == payloadId);
      if (order.qty == 1) {
        tempOrder.count -= 1;
        state.orders = state.orders.filter((order) => order.id !== payloadId);
      } else {
        tempOrder.count -= 1;
        order.qty -= 1;
      }
      order.purchase_total = order.purchase_price * order.qty;
      order.total = order.price * order.qty;
    },
    SET_SINGLE_ORDER_QTY: (state, payload) => {
      let selectedOrder = state.orders.find((order) => order.id == payload.id);
      selectedOrder.qty = payload.qty;
      selectedOrder.total = selectedOrder.qty * selectedOrder.sale_price;
    },
    DELETE_SINGLE_ORDER: (state, payloadId) => {
      let tempOrder = (state.tmpOrders.find(
        (order) => order.id == payloadId
      ).count = 0);
      state.orders = state.orders.filter((order) => order.id !== payloadId);
    },
    CLEAR_ORDER: (state) => {
      state.orders = [];
      state.total = 0;
      state.subtotal = 0;
      state.tax_discount.tax = " ";
      state.tax_discount.discount = " ";
    },
    // search
    SET_KEYWORD: (state, payload) => (state.keyword = payload),
    SET_TAX_DISCOUNT: (state, payload) => {
      state.tax_discount.tax = payload.tax;
      state.tax_discount.discount_percent = payload.discount_percent;
      state.tax_discount.discount = payload.discount;
      state.tax_discount.tax_price = payload.tax_price;
    },

    SET_TOTAL: (state, payload) => (state.total = payload),
    SET_SALE_PRICE_MODAL_ID: (state, payload) =>
      (state.salePriceModalId = payload),
    SET_SALT_PRICE_MODAL_STATUS: (state, payload) =>
      (state.showSalePriceModal = payload),
    SET_SALE_PRICE: (state, payload) => {
      let order = state.orders.find((ord) => ord.id == state.salePriceModalId);
      order.sale_price = payload;
      order.total = order.qty * order.sale_price;
    },
    // SET_PURCHASE_TOTAL: (state, payload) => console.log(payload),
    SET_SUBTOTAL: (state, payload) => (state.subtotal = payload),
    SET_PURCHASE_TOTAL: (state, payload) => (state.purchasetotal = payload),
    SET_HOLD_ORDERS: (state, payload) => state.holdOrders.unshift(payload),
    REMOVE_HOLD_ORDERS_BYIND: (state, payload) =>
    (state.holdOrders = state.holdOrders.filter(
      (ele, ind) => ind !== payload
    )),
    ENTER_REMARK: (state, { input, id }) => {
      state.orders.find((order) => order.id == id).remark = input;
    },
    SET_REFUND_PAID: (state, payload) => {
      state.refund_paid.refund = payload.refund;
      state.refund_paid.paid = payload.paid;
      state.refund_paid.customer_id = payload.customer_id;
      state.refund_paid.delivery_fee = payload.delivery_fee;
      state.refund_paid.delivery_status = payload.delivery_status;
      state.refund_paid.township_id = payload.township_id;
    },
    SET_SHOP_NAME: (state, payload) => {
      // console.log(payload);
      state.shop_info = payload;
    },
    SET_IS_RECEIPT: (state, payload) => {
      state.isReceipt = payload;
    },
    SET_CURRENT_CATEGORY_ID: (state, payload) => {
      state.curretnCategoryId = payload;
    },
  },
  actions: {
    setPaidRefund: ({ commit }, payload) => commit("SET_PAID_REFUND", payload),
    setStartPrint: ({ commit }, payload) => commit("SET_START_PRINT", payload),
    setShopName: ({ commit }, payload) => commit("SET_SHOP_NAME", payload),
    addTmpOrder: ({ commit }, payload) => commit("ADD_TMP_ORDER", payload),
    setOrderNumber: ({ commit }, payload) =>
      commit("SET_ORDER_NUMBER", payload),
    setCustomer: ({ commit }, payload)=>
      commit("SET_CUSTOMER",payload),
    addOrder: ({ commit }, payload) => commit("ADD_ORDER", payload),
    setOrder: ({ commit }, payload) => commit("SET_ORDER", payload),
    incOrder: ({ commit }, payloadId) => commit("INC_ORDER", payloadId),
    decOrder: ({ commit }, payloadId) => commit("DEC_ORDER", payloadId),
    setSingleOrderQty: ({ commit }, payload) =>
      commit("SET_SINGLE_ORDER_QTY", payload),
    clearOrder: ({ commit }) => commit("CLEAR_ORDER"),
    deleteSingleOrder: ({ commit }, payloadId) =>
      commit("DELETE_SINGLE_ORDER", payloadId),
    // search
    setKeyword: ({ commit }, payload) => commit("SET_KEYWORD", payload),

    setTax_Discount: ({ commit }, payload) =>
      commit("SET_TAX_DISCOUNT", payload),
    setSalePriceModalId: ({ commit }, payload) =>
      commit("SET_SALE_PRICE_MODAL_ID", payload),
    setSalePriceModalStatus: ({ commit,state }, payload) =>{
      const UserRole=state.UserRole;
      if (UserRole === "salesperson") {
        commit("SET_SALE_PRICE_MODAL_STATUS", payload);
      } else {
        console.warn("Unauthorized access: Only salespersons can perform this action.");
      }
    },
    setSalePrice: ({ commit }, payload) => commit("SET_SALE_PRICE", payload),
    setTotal: ({ commit }, payload) => commit("SET_TOTAL", payload),
    setPurchaseTotal: ({ commit }, payload) =>
      commit("SET_PURCHASE_TOTAL", payload),
    setSubTotal: ({ commit }, payload) => commit("SET_SUBTOTAL", payload),
    setHoldOrders: ({ commit }, payload) => commit("SET_HOLD_ORDERS", payload),
    removeHoldOrdersByInd: ({ commit }, payload) =>
      commit("REMOVE_HOLD_ORDERS_BYIND", payload),
    enterRemark: ({ commit }, payload) => commit("ENTER_REMARK", payload),
    setRefundPaid: ({ commit }, payload) => commit("SET_REFUND_PAID", payload),
    setIsReceipt: ({ commit }, payload) => commit("SET_IS_RECEIPT", payload),
    setCurrentCategoryId: ({ commit }, payload) =>
      commit("SET_CURRENT_CATEGORY_ID", payload),
  },
};
